import TechnologyExpertise from "./TechnologyExpertise";
import CompanySpecification from "./CompanySpecification";

export default function HomePage() {
  return (
    <>
      <TechnologyExpertise />
      <CompanySpecification />
    </>
  );
}
